import EcommerceUploadRoute from './EcommerceUploadRoute'
import EcommerceLabelRoute from './EcommerceLabelRoute'

const routes = [
    new EcommerceUploadRoute(),
    new EcommerceLabelRoute()
]

export default routes
